import { Directive } from '@angular/core';

@Directive({
  selector: '[rmsPageLayoutContent],rms-page-layout-content',
  host: {
    class: 'rms-page-layout-content',
  },
})
export class PageLayoutContentDirective {}
